<script setup>
// A thin <nav> wrapper so SideNav items sit in a landmark with correct spacing.
</script>

<template>
	<nav class="l-nav">
		<slot />
	</nav>
</template>

<style scoped>
.l-nav
{
	padding: 0 10px;
	display: flex;
	flex-direction: column;
	gap: 1px;
	/* flex: 1; */
	flex: 1 1 0%;
	min-height: 0;
	overflow-y: auto;
}
</style>
